import { render, staticRenderFns } from "./SwapTemplateModal.vue?vue&type=template&id=a2e3387e&scoped=true"
import script from "./SwapTemplateModal.vue?vue&type=script&lang=js"
export * from "./SwapTemplateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2e3387e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a2e3387e')) {
      api.createRecord('a2e3387e', component.options)
    } else {
      api.reload('a2e3387e', component.options)
    }
    module.hot.accept("./SwapTemplateModal.vue?vue&type=template&id=a2e3387e&scoped=true", function () {
      api.rerender('a2e3387e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/modals/SwapTemplateModal.vue"
export default component.exports